// services/useTestOpsGenieService.ts
import { useTestopsGenieApi } from '../../../store/api/hooks/testopsGenieApiHook'
import { useUserApi } from '../../../store/api/hooks/userApiHook'

export type getConversationListPayload = {
    access_token: string
    page: number
    page_size: number
    project_key: string
}
export type getChatHistoryPayload = {
    conversationID: string
    access_token: string
    project_key: string
}

export interface TestOpsGenieService {
    getTestOpsGenieToken: (setToken: (token: any) => void) => Promise<string | null>
    addUser: (genieAccessToken: string) => Promise<boolean>
    getConversationList: (payload: getConversationListPayload) => Promise<any>
    getChatHistory: (payload: getChatHistoryPayload) => Promise<any>
}

export const useTestOpsGenieService = (): TestOpsGenieService => {
    const userAPI = useUserApi()
    const GenieAPI: any = useTestopsGenieApi()

    const getTestOpsGenieToken = (setToken: (token: any) => void): Promise<string | null> => {
        return new Promise((resolve, reject) => {
            userAPI.getTestOpsCopilotToken(
                {},
                (resp: any) => {
                    const _token: any = resp?.data?.access_token ?? null
                    if (_token) {
                        setToken(_token)
                        resolve(_token)
                    } else {
                        localStorage.clear()
                        location.reload()
                    }
                },
                (err: any) => {
                    localStorage.clear()
                    location.reload()
                    reject(err)
                },
            )
        })
    }
    const addUser = (genieAccessToken: string): Promise<boolean> => {
        return new Promise((resolve) => {
            GenieAPI.addUser(
                { access_token: genieAccessToken },
                (resp: any) => {
                    resolve(true)
                },
                (err: any) => {
                    resolve(false)
                },
            )
        })
    }
    const getConversationList = (payload: getConversationListPayload): Promise<any> => {
        return new Promise((resolve, reject) => {
            GenieAPI.getConversationList(
                payload,
                (resp: any) => {
                    resolve(resp.data)
                },
                (err: any) => {
                    reject(err)
                },
            )
        })
    }
    const getChatHistory = (payload: getChatHistoryPayload): Promise<any> => {
        return new Promise((resolve, reject) => {
            GenieAPI.getChatHistory(
                payload,
                (resp: any) => {
                    resolve(resp.data)
                },
                (err: any) => {
                    reject(err)
                },
            )
        })
    }

    return {
        getTestOpsGenieToken,
        addUser,
        getConversationList,
        getChatHistory,
    }
}
